// ── 홍보물 명세 섹션 — OrderModal의 아이템 목록 편집 영역 ──────────────────────
import React from 'react';
import CourierInput from '../../../components/CourierInput';
import { ItemSearchInput } from './ItemSearchInput';
import { fmtPrice } from './utils';
import { sectionCard, sectionTitle, addItemBtnStyle, removeItemBtnStyle, inputStyle } from './styles';

// props:
//   items              — form.items 배열
//   totalAmount        — 합계 금액 (표시용)
//   promotionalItemsList — 검색 자동완성 소스
//   autoFocusNew       — 새 아이템 첫 검색창 자동 포커스 여부
//   onAutoFocused      — 자동 포커스 완료 콜백
//   onAddItem          — + 홍보물 추가 클릭
//   onSetItem(idx, key, val) — 아이템 필드 변경
//   onSelectItem(idx, found) — 검색 자동완성에서 선택
//   onRemoveItem(idx)  — 항목 삭제
export function OrderItemsList({
  items, totalAmount, promotionalItemsList,
  autoFocusNew, onAutoFocused,
  onAddItem, onSetItem, onSelectItem, onRemoveItem,
}) {
  return (
    <div style={sectionCard}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div style={sectionTitle}>홍보물 명세</div>
        {totalAmount > 0 && (
          <span style={{ fontSize: 13, fontWeight: 700, color: '#7c3aed' }}>합계: {fmtPrice(totalAmount)}</span>
        )}
      </div>
      {/* 홍보물 추가 버튼 — 목록 상단 */}
      <button style={addItemBtnStyle} onClick={onAddItem}>+ 홍보물 추가</button>
      {items.map((item, idx) => (
        <div key={idx} style={{ marginBottom: 10, padding: '8px 10px', background: 'var(--bg-subtle)', borderRadius: 8, border: '1px solid var(--border)', minWidth: 0, boxSizing: 'border-box' }}>
          {/* 홍보물 + 수량 + 삭제 */}
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 6, flexWrap: 'wrap' }}>
            <ItemSearchInput
              value={item.item_name}
              unitPrice={item.unit_price}
              promotionalItemsList={promotionalItemsList}
              onSelect={(found) => onSelectItem(idx, found)}
              autoFocus={idx === 0 && autoFocusNew}
              onAutoFocused={onAutoFocused}
            />
            <input
              type="text" inputMode="numeric" pattern="[0-9]*"
              style={{ ...inputStyle, width: 56, flexShrink: 0 }}
              placeholder="수량"
              value={item.quantity}
              onChange={(e) => onSetItem(idx, 'quantity', e.target.value.replace(/[^0-9]/g, ''))}
            />
            <span style={{ fontSize: 12, color: 'var(--text-sub)', flexShrink: 0 }}>개</span>
            <button type="button" style={{ ...removeItemBtnStyle, flexShrink: 0 }} onClick={() => onRemoveItem(idx)}>삭제</button>
          </div>
          {/* 아이템별 택배사 + 송장번호 (송장불필요 항목은 뱃지로 대체) */}
          {item.no_shipping ? (
            <span style={{ fontSize: 11, fontWeight: 400, padding: '2px 9px', borderRadius: 10, background: 'var(--border)', color: 'var(--text-muted)', display: 'inline-block', marginTop: 2 }}>
              송장불필요
            </span>
          ) : (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              <CourierInput
                value={item.courier}
                onChange={(v) => onSetItem(idx, 'courier', v)}
                placeholder="택배사"
                style={{ flex: '1 1 140px', minWidth: 0 }}
              />
              <input
                style={{ ...inputStyle, flex: '1 1 160px', minWidth: 0 }}
                placeholder="송장번호"
                value={item.tracking_number}
                onChange={(e) => onSetItem(idx, 'tracking_number', e.target.value)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
